/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final balance`)
};

const es_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo final`)
};

const de_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endsaldo`)
};

const nl_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eindersaldo`)
};

const fr_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solde final`)
};

const it_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo finale`)
};

const pt_br2_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo final`)
};

const pt_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo final`)
};

const ja_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終残高`)
};

const zh_cp_balance_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最终余额`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_balance_out = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_balance_out(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_balance_out", locale)
	if (locale === "en") return en_cp_balance_out(inputs)
	if (locale === "es") return es_cp_balance_out(inputs)
	if (locale === "de") return de_cp_balance_out(inputs)
	if (locale === "nl") return nl_cp_balance_out(inputs)
	if (locale === "fr") return fr_cp_balance_out(inputs)
	if (locale === "it") return it_cp_balance_out(inputs)
	if (locale === "pt-BR") return pt_br2_cp_balance_out(inputs)
	if (locale === "pt") return pt_cp_balance_out(inputs)
	if (locale === "ja") return ja_cp_balance_out(inputs)
	return zh_cp_balance_out(inputs)
};